<div class="container-fluid mt-3 monitor-page">
  <!-- En-tête compact : identité + actions rares regroupées -->
  @if (monitor) {
    <div class="monitor-header">
      <div class="monitor-header__identity">
        <span class="monitor-header__avatar" [style.background]="monitor.color || '#2c3e50'">{{ initials }}</span>
        <div>
          <h3 class="monitor-header__name">{{ monitorName | uppercase }} <small class="text-muted">#{{ monitor.id }}</small></h3>
          <div class="monitor-header__contact">
            @if (monitor.phoneNumber) {
              <span><i class="fa fa-phone"></i> {{ monitor.phoneNumber }}</span>
            }
            @if (monitor.email) {
              <span><i class="fa fa-envelope-o"></i> {{ monitor.email }}</span>
            }
          </div>
        </div>
      </div>
      <div class="monitor-header__actions">
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="onShowMoniteurPlug()">
          <i class="fa" [ngClass]="showMonitorPlug ? 'fa-chevron-up' : 'fa-id-card-o'"></i>
          {{ showMonitorPlug ? 'Masquer la fiche' : 'Voir la fiche' }}
        </button>
        @if (!readOnlyService.isReadOnly()) {
          <div class="dropdown d-inline-block">
            <button type="button" class="btn btn-sm btn-outline-secondary dropdown-toggle" data-bs-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
              <i class="fa fa-cog"></i> Actions
            </button>
            <div class="dropdown-menu dropdown-menu-end">
              <a class="dropdown-item" role="button" (click)="onEditFromMenu()"><i class="fa fa-pencil fa-fw"></i> Modifier la fiche</a>
              <a class="dropdown-item" role="button" (click)="onOpenUserForm()"><i class="fa fa-key fa-fw"></i> Mot de passe</a>
              <a class="dropdown-item" role="button" (click)="onOpenRolesForm()"><i class="fa fa-shield fa-fw"></i> Rôles</a>
            </div>
          </div>
        }
      </div>
    </div>
  }

  @if (showMonitorPlug) {
    <div class="monitor-plug">
      @if (messageError != null && messageError.length > 0) {
        <div class="alert alert-danger" role="alert">
          <p class="alert-heading mb-0">Une erreur a été rencontrée : {{messageError}}</p>
          <hr>
          </div>
        }
        @if (isSaved) {
          <div class="alert alert-success" role="alert">
            <p class="alert-heading mb-0">La mise à jours est réussie !</p>
            <hr>
            </div>
          }
          @if (monitorForm) {
            <form class="needs-validation" id="saveMonitorForm" [formGroup]="monitorForm" #f="ngForm"
              (ngSubmit)="canSubmit && f.form.valid && onEditMonitor()" novalidate>
              <div class="form-row">
                <div class="col-md-4 mb-3">
                  <label for="madam"></label>
                  <div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input input-form" type="radio" name="sexe" formControlName="sexe" id="madam" value="F">
                      <label class="form-check-label" for="madam">MADAME</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input input-form" type="radio" name="sexe" formControlName="sexe" id="sir" value="M">
                      <label class="form-check-label" for="sir">MONSIEUR</label>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 mb-3">
                  <label for="name">Couleur</label>
                  <input type="color" class="form-control input-form" name="color" formControlName="color">
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-4 mb-3">
                  <label for="name">Nom</label>
                  <input type="text" class="form-control input-form" id="name" formControlName="lastname" placeholder="Nom" required>
                  @if (canSubmit && (f.form.controls.lastname.status == 'INVALID')) {
                    <p class="p-alert" role="alert">
                      Merci de définir le nom !
                    </p>
                  }
                </div>
                <div class="col-md-4 mb-3">
                  <label for="firstname">Prénom</label>
                  <input type="text" class="form-control input-form" id="firstname" formControlName="firstname" placeholder="Prénom" required>
                  @if (canSubmit && (f.form.controls.firstname.status == 'INVALID')) {
                    <p class="p-alert" role="alert">
                      Merci de définir le prénom !
                    </p>
                  }
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-4 mb-3">
                  <label for="email">Email</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="inputGroupPrepend">&#64;</span>
                    </div>
                    <input type="email" class="form-control input-form" id="email" formControlName="email" placeholder="Email" required>
                  </div>
                  @if (canSubmit && (f.form.controls.email.status === 'INVALID')) {
                    <p class="p-alert" role="alert">
                      Email invalide ou déjà utilisé !
                    </p>
                  }
                </div>
                <div class="col-md-4 mb-3">
                  <label for="phoneNumber">Téléphone</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">T</span>
                    </div>
                    <input type="text" class="form-control input-form" id="phoneNumber" formControlName="phoneNumber" placeholder="Téléphone" required>
                  </div>
                  @if (canSubmit && (f.form.controls.phoneNumber.status == 'INVALID')) {
                    <p class="p-alert" role="alert">
                      Merci de définir un numéro de téléphone !
                    </p>
                  }
                </div>
              </div>
              <div class="d-flex justify-content-end">
                @if (canSubmit) {
                  <button type="button" class="btn btn-outline-secondary me-2" (click)="onCancelEdit()">Annuler</button>
                }
                @if (canSubmit) {
                  <button class="btn btn-primary" type="submit" (click)="isSubmited(f.form)">Enregistrer</button>
                }
              </div>
            </form>
          }
        </div>
      }


      <app-calendar>
      </app-calendar>
    </div>

    @if (monitor) {
      <app-user-update-pwd [iMonitor]="monitor"></app-user-update-pwd>
    }

    <div class="modal fade" id="userRolesModal" tabindex="-1" role="dialog" aria-labelledby="userRolesLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="userRolesLabel"><i class="fa fa-shield"></i> Rôles du compte</h5>
            <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- chargé uniquement à l'ouverture -->
            @if (monitor && showRoles) {
              <app-user-roles [iEmail]="monitor.email"></app-user-roles>
            }
          </div>
        </div>
      </div>
    </div>
